var _defs, _g, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgData(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080 1080",
    width: 1080,
    height: 1080,
    preserveAspectRatio: "xMidYMid meet",
    style: {
      width: "100%",
      height: "100%",
      transform: "translate3d(0px, 0px, 0px)",
      contentVisibility: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_3786"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1080,
    height: 1080,
    x: 0,
    y: 0
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_3786)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,315,540)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,221,179)",
    fillOpacity: 1,
    d: " M50,0 C50,0 50,0 50,0 C50,27.594999313354492 27.594999313354492,50 0,50 C0,50 0,50 0,50 C-27.594999313354492,50 -50,27.594999313354492 -50,0 C-50,0 -50,0 -50,0 C-50,-27.594999313354492 -27.594999313354492,-50 0,-50 C0,-50 0,-50 0,-50 C27.594999313354492,-50 50,-27.594999313354492 50,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,465,540)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,221,179)",
    fillOpacity: 1,
    d: " M50,0 C50,0 50,0 50,0 C50,27.594999313354492 27.594999313354492,50 0,50 C0,50 0,50 0,50 C-27.594999313354492,50 -50,27.594999313354492 -50,0 C-50,0 -50,0 -50,0 C-50,-27.594999313354492 -27.594999313354492,-50 0,-50 C0,-50 0,-50 0,-50 C27.594999313354492,-50 50,-27.594999313354492 50,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,615,540)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,221,179)",
    fillOpacity: 1,
    d: " M50,0 C50,0 50,0 50,0 C50,27.594999313354492 27.594999313354492,50 0,50 C0,50 0,50 0,50 C-27.594999313354492,50 -50,27.594999313354492 -50,0 C-50,0 -50,0 -50,0 C-50,-27.594999313354492 -27.594999313354492,-50 0,-50 C0,-50 0,-50 0,-50 C27.594999313354492,-50 50,-27.594999313354492 50,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,765,540)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,221,179)",
    fillOpacity: 1,
    d: " M50,0 C50,0 50,0 50,0 C50,27.594999313354492 27.594999313354492,50 0,50 C0,50 0,50 0,50 C-27.594999313354492,50 -50,27.594999313354492 -50,0 C-50,0 -50,0 -50,0 C-50,-27.594999313354492 -27.594999313354492,-50 0,-50 C0,-50 0,-50 0,-50 C27.594999313354492,-50 50,-27.594999313354492 50,0z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/data.ad202f889f42546a1c2a4680a04f7b48.svg";
export { ForwardRef as ReactComponent };